import { InfoAdapterType } from "features/shared/types/info";
import { Article } from "../types/article";

export const unflattenArticle = (
    flattenedArticle: Record<string, any>
): Article => {
    let unflattenedArticle: Article = {
        id: flattenedArticle.id,
        tags: flattenedArticle.tags ? flattenedArticle.tags.split(",") : [],
        type: flattenedArticle.type,
        properties: {
            type: InfoAdapterType.DefaultInfo, // product only uses this
        },
    };

    if (flattenedArticle.name_en || flattenedArticle.name_th) {
        unflattenedArticle.properties.name = {
            en: flattenedArticle.name_en || "",
            th: flattenedArticle.name_th || "",
        };
    }
    if (flattenedArticle.description_en || flattenedArticle.description_th) {
        unflattenedArticle.properties.description = {
            en: flattenedArticle.description_en || "",
            th: flattenedArticle.description_th || "",
        };
    }

    flattenedArticle.image &&
        (unflattenedArticle.properties.image = flattenedArticle.image);
    flattenedArticle.seo &&
        (unflattenedArticle.properties.seo = flattenedArticle.seo);
    flattenedArticle.rank &&
        (unflattenedArticle.properties.rank = flattenedArticle.rank);
    flattenedArticle.viewCount &&
        (unflattenedArticle.properties.viewCount = flattenedArticle.viewCount);
    flattenedArticle.isHidden &&
        (unflattenedArticle.properties.isHidden = flattenedArticle.isHidden);

    return unflattenedArticle;
};

export const flattenArticle = (article: Article) => {
    return {
        id: article.id,
        name_en: article.properties.name?.en,
        name_th: article.properties.name?.th,
        description_en: article.properties.description?.en,
        description_th: article.properties.description?.th,
        image: article.properties.image,
        seo: article.properties.seo,
        rank: article.properties.rank,
        viewCount: article.properties.viewCount,
        isHidden: article.properties.isHidden,
        tags: article.tags.join(","),
        type: article.type,
    };
};
